const routes = [
    {
        name: 'historic-reports',
        path: '/',
        meta: { title: 'historic-reports', requiresAuth: false },
        component: () => import('@/views/const/space'),
        route: true,
    },

]

export default [
    {
        path: '/historic-reports',
        route: false,
        component: () => import('@/layout/brief'),
        children: [...routes],
    },
]